/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/prop-types */
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import event_cancel from '../../assets/icons/preveiw_cancel.svg';

export default function CustomModal({
  children,
  open,
  close,
  heading,
  action,
  size,
  icon,
  headingColor = 'primary',
  canceltext,
  extraButton,
  iconClick,
}) {
  return (
    <Dialog
      open={open}
      onClose={close}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
      maxWidth={size ? size : 'sm'}
    >
      <DialogTitle id="scroll-dialog-title">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography color="primary" variant="h3">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {icon && (
                <IconButton onClick={iconClick}>
                  <Box component="img" src={icon} />
                </IconButton>
              )}
              <Typography variant="h3" color={headingColor}>
                {heading}
              </Typography>
            </Box>
          </Typography>
          <IconButton onClick={close}>
            <Box component="img" src={event_cancel} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers={true}>{children}</DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '15px 20px',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0px 0px 15px 5px',
            width: '100%',
          }}
        >
          <Button type="button" variant="outlined" onClick={close}>
            {canceltext || 'Cancel'}
          </Button>
          {action}
        </Box>
        {extraButton}
      </DialogActions>
    </Dialog>
  );
}
